import React, { useContext, useState, useEffect } from "react";
import { Container, Col, Button, Row } from "react-bootstrap";
import "./ServiceRequest.scss";
import { useHistory } from "react-router-dom";
// import { TabView, TabPanel } from "primereact/tabview";
import { Paginator } from "primereact/paginator";
import { useQuery, gql, useMutation, useLazyQuery } from "@apollo/client";
import { MyContext } from "../Dashboard/Dashboard";
import Loader from "react-loader-spinner";
import moment from "moment";
import ReactTooltip from "react-tooltip";
import { FiAlertTriangle } from "react-icons/fi";
const ServiceRequest = (props) => {
  let { setServiceRecordList, vesselIMO, vesselImage, vesselName } =
    useContext(MyContext);
  let history = useHistory();
  const {
    match: { params },
  } = props;
  const { cid, vid } = params;
  const [first, setFirst] = useState(1);
  const [rows, setRows] = useState(10);
  const [serviceDetailList, setServiceDetails] = useState([]);
  const [requestListStatus, setRequestListStatus] = useState(null);
  const [showPendingTab, setShowPendingTab] = useState(false);
  const [showTabs, setShowTabs] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [pendingCount, setPendingCount] = useState(0);
  const [allCount, setAllCount] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);

  useEffect(() => {
    setFirst(1);
    setRows(10);
    getRequestList();
  }, []);
  useEffect(() => {
    if (!isInitialLoad) {
      getRequestList();
    }
  }, [first, rows]);
  useEffect(() => { }, [vesselIMO]);
  useEffect(() => { }, [vesselImage]);
  useEffect(() => { }, [vesselName]);

  const onPageChange = (event) => {
    if (event) {
      setFirst(event.page + 1);
      setRows(event.rows);
    }
  };

  const list_query = gql`
  query{serviceRequestListByVesselParty(vesselId:${vid},custId:${cid},pageNumber:${first},pageSize:${rows},serviceRequestTypeCode:"RAR",
  requestListStatus:${requestListStatus ? `"${requestListStatus}"` : "null"
    })
    {
      requests {
        requestId
        serviceRequestTypeCode
        approverRoleCode
        approverRoleName
        title
        description
        createdDate
        workflow
        equipment
        status
        isWarrantyEnabled
        estimateStartDate
        estimateEndDate
        customer
        vessel
        isAssignee
        currentAssigneeJob 
      }
      isPendingOnly
      totalCount 
    }
  }`;

  const [getRequestList, { loading, error, data }] = useLazyQuery(list_query, {
    fetchPolicy: "cache-and-network",
    onCompleted(resp) {
      if (
        resp.serviceRequestListByVesselParty.requests &&
        resp.serviceRequestListByVesselParty.requests.length
      ) {
        let response = JSON.parse(JSON.stringify(resp));
        setTotalRecords(response.serviceRequestListByVesselParty.totalCount || 0);
        response.serviceRequestListByVesselParty.requests.map((data, index) => {
          if (data['createdDate']) {
            data['createdText'] = 'Request was created on : ' + (moment.utc(data['createdDate'], 'M/D/YYYY hh:mm:ss A').local().format('DD-MM-YYYY HH:mm:ss a')).toString();
          }
        })
        // Only first load should decide tab visibility
        if (isInitialLoad) {
          setShowTabs(
            response.serviceRequestListByVesselParty.isPendingOnly
          );
          if (
            response.serviceRequestListByVesselParty.isPendingOnly
          ) {
            setPendingCount(
              response.serviceRequestListByVesselParty.totalCount
            );
            setRequestListStatus("Pending");
          } else {
            setAllCount(
              response.serviceRequestListByVesselParty.totalCount
            );
            setRequestListStatus("All");
          }
          setIsInitialLoad(false);
        }
        // Update counts whenever user switches tabs
        if (requestListStatus === "Pending") {
          setPendingCount(response.serviceRequestListByVesselParty.totalCount);
        }

        if (requestListStatus === "All") {
          setAllCount(response.serviceRequestListByVesselParty.totalCount);
        }
        setServiceDetails(response.serviceRequestListByVesselParty.requests);
      }
    },
    onError(error) { },
  });

  const goToServiceDetailswithID = (service) => {
    if (service) {
      setServiceRecordList(service);
    }
    history.push(
      `/customers/${cid}/vessel/${vid}/operations/serviceRequest/serviceDetails/${service.requestId}`
    );
  };

  const goToNewServiceRequest = () => {
    history.push(
      `/customers/${cid}/vessel/${vid}/operations/newServiceRequest`
    );
  };
  const handleAllClick = () => {
    setRequestListStatus("All");
    setServiceDetails([]);
    setFirst(1);
  };
  const handlePendingClick = () => {
    setRequestListStatus("Pending");
    setServiceDetails([]);
    setFirst(1);
  };
  const getDateFormat = (date) => {
    return moment.utc(date).local().format("DD-MM-YYYY HH:mm:ss a");
  };


  const isCurrentTimeBetween = (startMs, endMs, inclusive = true) => {
    if (!Number.isFinite(startMs) || !Number.isFinite(endMs)) return false;
    if (startMs > endMs) return false;

    const start = moment(startMs);
    const end = moment(endMs);
    const now = moment();

    return now.isBetween(start, end, undefined, inclusive ? "[]" : "()");
  };


  const printStatus = (service, i) => {
    let status = service.status;
    let workflow = service.workflow;
    if (service.currentAssigneeJob !== "Service Engineer") {
      if (service.approverRoleName !== null) {
        return (
          <div class="statusMsg">
            <span className="">{workflow}: {status} </span> <br></br>
            <span className="pending">
              Pending with {service.approverRoleName}{" "}{service.workflow === "Access Request Raised" ? ' for approval.' : null}
            </span>
          </div>
        );
      } else {
        return <span className="pending">Pending</span>;
      }
    } else {
      let today = moment();
      let start = service.estimateStartDate;
      let end = service.estimateEndDate;

      if (today.isBefore(start, "second")) {
        if (status == 'Cancelled') {
          return (
            <div class="statusMsg">
              <span className="">{workflow}: {status}</span> <br></br>
              <span className="cancel"> Cancelled</span>
            </div>
          );
        }
        else {
          return (
            <div class="statusMsg">
              <span className="">{workflow}: {status}</span> <br></br>
              <span className="pending">
                Pending with {service.currentAssigneeJob}{" "}{service.workflow === "Access Request Raised" ? ' for approval.' : null}
              </span>
            </div>
          );
        }
      } else if (today.isAfter(end, "second") && (workflow == 'Request Approval' && status == "Completed") && service.revokeAccessDetails == null) {
        return (
          <div class="statusMsg">
            <span className="">{workflow}: {status}</span> <br></br>
            <span>Session Ended</span>
          </div>)
      }
      else if (service.revokeAccessDetails != null) {
        return (
          <div class="statusMsg">
            <span className="">{workflow}: {status}</span> <br></br>
            <div className="revoke-session-status">
              <span className="revoke-session-status-icon" ><FiAlertTriangle color="#FF3B3B" size={16} /></span><span className="revoke-session-status-txt">Session Revoked</span>
            </div>
          </div>)
      }
      else if (today.isAfter(end, "second") && (workflow == 'Report Work' && status == "Completed") && service.revokeAccessDetails == null) {
        return (
          <div class="statusMsg">
            <span className="">{workflow}: {status}</span> <br></br>
            <span>Ended</span>
          </div>)
      } else {
        if (status == 'Cancelled') {
          return <div class="statusMsg">
            <span className="">{workflow}: {status}</span> <br></br>
            <span className="cancel"> Cancelled</span>
          </div>
        }
        else {
          return (
            <div class="statusMsg">
              <span className="">{workflow}: {status}</span> <br></br>
              <span className="active">Active</span>
            </div>
          )

        }
      }
    }
  };

  return (
    <div className="customers service-request-wrapper">
      <div className="header-section">
        <h5>TRITON Reporter</h5>
        <div className="title">
          <div className="welcome">
            <div className="user-box">
              {localStorage.getItem("vesselImage") &&
                localStorage.getItem("vesselImage") !== "null" ? (
                <img src={localStorage.getItem("vesselImage")} alt="" />
              ) : (
                <img src="user-icon" alt="" />
              )}
            </div>
            <div className="vessel-name">
              {localStorage.getItem("vesselName")}
            </div>
            {localStorage.getItem("vesselIMO") &&
              localStorage.getItem("vesselIMO") !== "null" ? (
              <div className="vessel-number">
                IMO : {localStorage.getItem("vesselIMO")}
              </div>
            ) : (
              <div className="vessel-number">IMO : N.A</div>
            )}
          </div>
          <div className="sub-header">Service Requests</div>
        </div>
      </div>
      <div className="service-request">
        {showTabs && (<div className="request-tabs-header">
          <div
            className={`request-tab ${requestListStatus === "Pending" ? "active" : ""
              }`}
            onClick={handlePendingClick}
          >
            Pending

            {requestListStatus === "Pending" && pendingCount != 0 && (
              <span className="request-count">
                {pendingCount > 999 ? '999+' : pendingCount}
              </span>
            )}
          </div>

          <div
            className={`request-tab ${requestListStatus === "All" ? "active" : ""
              }`}
            onClick={handleAllClick}
          >
            All
            {requestListStatus === "All" && allCount != 0 && (
              <span className="request-count">
                {allCount > 999 ? '999+' : allCount}
              </span>
            )}
          </div>
        </div>)}
        {requestListStatus === "All" &&
          pendingCount != 0 && (
            <div className="review-banner">
              {pendingCount > 999 ? '999+' : pendingCount} - Requests Need Your Approval

              <span
                className="review-link"
                onClick={() => setRequestListStatus("Pending")}
              >
              </span>
            </div>
          )}

        {loading && (
          <div className="loader">
            <Loader
              type="TailSpin"
              color=" #2546B1"
              height={80}
              width={80}
              timeout={300000}
            />
          </div>
        )}

        {!loading && (
          <Container fluid="md">
            {serviceDetailList.length > 0 ? (
              serviceDetailList.map((service, i) => (
                <Row
                  className="service-request-details-chief-engineer"
                  key={i}
                >
                  <div className="header-text pl-3 pt-2 pr-3">
                    <div className="general-description pl-2">
                      {service.isWarrantyEnabled && (
                        <span
                          data-tip
                          data-for="warranty-tooltip-rqst1"
                          className="warranty-icon"
                          onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                          }}
                          onMouseDown={(e) => {
                            e.stopPropagation();
                          }}
                        >
                          <i className="pi pi-shield"></i>
                          <i className="pi pi-check"></i>

                          <ReactTooltip
                            id="warranty-tooltip-rqst1"
                            type="dark"
                            effect="float"
                            place="right"
                          >
                            Under Warranty
                          </ReactTooltip>
                        </span>
                      )}
                      {service.title}
                    </div>

                    <span
                      data-tip={service.createdText}
                      data-for="request-description"
                      className="desc-tool-tip"
                      onMouseDown={(e) => e.stopPropagation()}
                      onClick={(e) => e.stopPropagation()}
                    >
                      i
                    </span>

                    <ReactTooltip
                      id="request-description"
                      type="dark"
                      effect="float"
                      place="right"
                      className="rqst-desc"
                      globalEventOff="click"
                    />
                  </div>

                  <Col
                    className="row-details p-3"
                    onClick={() => goToServiceDetailswithID(service)}
                  >
                    <div className="specific-details">
                      <div className="requestStyle">
                        {service.equipment}
                      </div>

                      <div className="date-container">
                        <div
                          className={`request-timestamp dateStyle ${service.status === "Completed" &&
                            service.workflow === "Request Approval" &&
                            isCurrentTimeBetween(
                              service.estimateStartDate,
                              service.estimateEndDate
                            )
                            ? "is-active-request"
                            : ""
                            }`}
                        >
                          {getDateFormat(service.estimateStartDate)}
                        </div>

                        <div
                          className="arrow-between arrow-triangle"
                          aria-hidden="true"
                        />

                        <div
                          className={`request-timestamp dateStyle ${service.status === "Completed" &&
                            service.workflow === "Request Approval" &&
                            isCurrentTimeBetween(
                              service.estimateStartDate,
                              service.estimateEndDate
                            )
                            ? "is-active-request"
                            : ""
                            }`}
                        >
                          {getDateFormat(service.estimateEndDate)}
                        </div>
                      </div>

                      <div className="request-status">
                        {printStatus(service, i)}
                      </div>
                    </div>
                  </Col>
                </Row>
              ))
            ) : (
              <div className="no-record">No Records Found</div>
            )}
          </Container>
        )}
      </div>
      {/* <div className="service-request">
        <TabView
          activeIndex={activeIndex}
          onTabChange={(e) => setIndexTabContent(e)}
        >
          <TabPanel header="Assigned">
            {loading && (
              <div className="loader">
                <Loader
                  type="TailSpin"
                  color=" #2546B1"
                  height={80}
                  width={80}
                  timeout={300000}
                />
              </div>
            )}
            {!loading && (
              <Container fluid="md">
                {serviceDetailList.length > 0 ? (
                  serviceDetailList.map((service, i) => (
                    <Row
                      className="service-request-details-chief-engineer"
                      key={i}
                    >
                      <div class="header-text pl-3 pt-2 pr-3">                       
                        <div className="general-description pl-2">
                          {service.isWarrantyEnabled && (
                            <span
                              data-tip
                              data-for={`warranty-tooltip-rqst1`}
                              className="warranty-icon"
                              onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                              }}
                              onMouseDown={(e) => {
                                e.stopPropagation();
                              }}
                            >
                              <i className="pi pi-shield"></i>
                              <i className="pi pi-check"></i>

                              <ReactTooltip
                                id={`warranty-tooltip-rqst1`}
                                type="dark"
                                effect="float"
                                place="right"
                              >
                                Under Warranty
                              </ReactTooltip>
                            </span>
                          )}
                           {service.title}
                        </div>
                        <span data-tip={service.createdText} data-for="request-description" className="desc-tool-tip"
                          onMouseDown={(e) => e.stopPropagation()}
                          onClick={(e) => {
                            e.stopPropagation();
                          }}>
                          i
                        </span>
                        <ReactTooltip
                          id="request-description"
                          type="dark"
                          effect="float"
                          place="right"
                          className="rqst-desc"
                          globalEventOff="click"
                        >
                        </ReactTooltip>
                      </div>
                      <Col
                        className="row-details p-3"
                        onClick={() => goToServiceDetailswithID(service)}
                      >
                        <div className="specific-details">
                          <div className="requestStyle">
                            {service.equipment}
                          </div>
                          <div className="date-container">
                            <div className={`request-timestamp dateStyle ${service.status == 'Completed' && service.workflow == 'Request Approval' && isCurrentTimeBetween(service.estimateStartDate, service.estimateEndDate) ? "is-active-request" : ""}`}>
                              {getDateFormat(service.estimateStartDate)}
                            </div>
                            <div className="arrow-between arrow-triangle" aria-hidden="true" />
                            <div className={`request-timestamp dateStyle ${service.status == 'Completed' && service.workflow == 'Request Approval' && isCurrentTimeBetween(service.estimateStartDate, service.estimateEndDate) ? "is-active-request" : ""}`}>
                              {getDateFormat(service.estimateEndDate)}
                            </div>
                          </div>
                          <div className="request-status">
                            {printStatus(service, i)}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  ))
                ) : (
                  <div className="no-record">No Records Found</div>
                )}
              </Container>
            )}
          </TabPanel>
          <TabPanel header="Raised">
            {" "}
            {loading && (
              <div className="loader">
                <Loader
                  type="TailSpin"
                  color=" #2546B1"
                  height={80}
                  width={80}
                  timeout={300000}
                />
              </div>
            )}
            {!loading && (
              <Container fluid="md">
                {serviceDetailList.length > 0 ? (
                  serviceDetailList.map((service, i) => (
                    <Row
                      className="service-request-details-chief-engineer"
                      key={i}
                    >
                      <Col
                        className="row-details p-3"
                        onClick={() => goToServiceDetailswithID(service)}
                      >
                            <div className="general-description pl-2">
                          {service.isWarrantyEnabled && (
                            <span
                              data-tip
                              data-for={`warranty-tooltip-rqst`}
                              className="warranty-icon"
                              onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                              }}
                              onMouseDown={(e) => {
                                e.stopPropagation();
                              }}
                            >
                              <i className="pi pi-shield"></i>
                              <i className="pi pi-check"></i>

                              <ReactTooltip
                                id={`warranty-tooltip-rqst`}
                                type="dark"
                                effect="float"
                                place="right"
                              >
                                Under Warranty
                              </ReactTooltip>
                            </span>
                          )}
                          {service.description}
                        </div>

                        <div className="specific-details">
                          <div className="requestStyle">
                            {service.equipment}
                          </div>
                          <div className="request-timestamp">
                            {getDateFormat(service.createdDate)}
                          </div>
                          <div className="request-status">
                            {printStatus(service, i)}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  ))
                ) : (
                  <div className="no-record">No Records Found</div>
                )}
              </Container>
            )}
          </TabPanel>
        </TabView>
      </div> */}
      <div className="service-request-remote-access-list-approver">
        <div className="card">
          <Paginator
            first={(first - 1) * rows}
            rows={rows}
            totalRecords={totalRecords}
            rowsPerPageOptions={[10, 20, 30]}
            onPageChange={onPageChange}
          />
        </div>
        <Button
          className="request-access-button"
          onClick={() => goToNewServiceRequest()}
          style={{ display: "none" }}
        >
          Raise Request
        </Button>
      </div>
    </div>
  );
};

export default ServiceRequest;
